<!-- 饼图的配置 -->

<template>
  <el-collapse accordion class="average-width">
    <el-collapse-item title="指标卡样式设置" name="1">
      <el-form-item labelAlign="left" label="指标卡风格">
        <el-radio-group v-model="main.activeOption.cardType" size="small">
          <el-radio-button :label="CARD_TYPE.OPT">圆点</el-radio-button>
          <el-radio-button :label="CARD_TYPE.LINE">带侧边条</el-radio-button>
          <el-radio-button :label="CARD_TYPE.BG">背景填充</el-radio-button>
          <el-radio-button :label="CARD_TYPE.NONE">无</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item labelAlign="left" label="主指标间距">
        <el-input-number min="0" v-model="main.activeOption.mainGap" size="small"
                         controls-position="right"></el-input-number>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标间距">
        <el-input-number min="0" v-model="main.activeOption.intervalGap" size="small"
                         controls-position="right"></el-input-number>
      </el-form-item>
      <el-form-item labelAlign="left" label="主主指标布局">
        <el-radio-group v-model="main.activeOption.layoutType" size="small">
          <el-radio-button label="row">横排</el-radio-button>
          <el-radio-button label="column">竖排</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item labelAlign="left" label="主辅指标布局">
        <el-radio-group v-model="main.activeOption.mainAssistType" size="small">
          <el-radio-button label="row">横排</el-radio-button>
          <el-radio-button label="column">竖排</el-radio-button>
          <el-radio-button label="column_row">主竖辅横</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="main.activeOption.cardType === CARD_TYPE.LINE">
        <el-form-item labelAlign="left" label="边条颜色">
          <el-color-picker :predefine="predefineColors" v-model="main.activeOption.lineColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" label="边条宽度">
          <el-input-number min="0" v-model="main.activeOption.lineWidth" size="small"
                           controls-position="right"></el-input-number>
        </el-form-item>
      </template>

      <template v-if="main.activeOption.cardType === CARD_TYPE.BG">
        <el-form-item labelAlign="left" label="背景色类型">
          <el-radio-group v-model="main.activeOption.colorType" size="small">
            <el-radio-button label="single">单色</el-radio-button>
            <el-radio-button label="multiple">多色</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item labelAlign="left" label="背景颜色">
          <el-dropdown v-if="main.activeOption.colorType === 'multiple'" trigger="click" class="mt-10"
                       @command="changeColor" size="small">
            <div class="pointer flex vcenter">
              <img v-if="main.activeOption.selectedColorIndex == 0" style="height: 34px"
                   src="@/assets/images/color0.png"/>
              <img v-if="main.activeOption.selectedColorIndex == 1" style="height: 34px"
                   src="@/assets/images/color1.png"/>
              <img v-if="main.activeOption.selectedColorIndex == 2" style="height: 34px"
                   src="@/assets/images/color2.png"/>
              <img v-if="main.activeOption.selectedColorIndex == 3" style="height: 34px"
                   src="@/assets/images/color3.png"/>
              <img v-if="main.activeOption.selectedColorIndex == 4" style="height: 34px"
                   src="@/assets/images/color4.png"/>
              <el-icon class="el-icon--right ml-4">
                <ArrowDown/>
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="0">
                  <img style="height: 34px" src="@/assets/images/color0.png"/>
                </el-dropdown-item>
                <el-dropdown-item command="1">
                  <img style="height: 34px" src="@/assets/images/color1.png"/>
                </el-dropdown-item>
                <el-dropdown-item command="2">
                  <img style="height: 34px" src="@/assets/images/color2.png"/>
                </el-dropdown-item>
                <el-dropdown-item command="3">
                  <img style="height: 34px" src="@/assets/images/color3.png"/>
                </el-dropdown-item>
                <el-dropdown-item command="4">
                  <img style="height: 34px" src="@/assets/images/color4.png"/>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-color-picker :predefine="predefineColors" v-else
                           v-model="main.activeOption.customColor"></el-color-picker>
        </el-form-item>
      </template>
      <!--			<el-form-item  labelAlign="left" label="标题位置">-->
      <!--				<el-radio-group v-model="main.activeOption.titlePosition">-->
      <!--					<el-radio label="top">上</el-radio>-->
      <!--					<el-radio label="bottom">下</el-radio>-->
      <!--				</el-radio-group>-->
      <!--			</el-form-item>-->
      <div class="color b pl-10">主指标：</div>
      <el-form-item labelAlign="left" label="维度字色" tip="配置单个指标标题的样式">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.titleColor"></el-color-picker>
      </el-form-item>
      <el-form-item labelAlign="left" label="维度字号">
        <el-input-number min='0' v-model="main.activeOption.titleFontSize" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="维度字重">
        <el-select clearable v-model="main.activeOption.titleWeight" size="small">
          <el-option label="细" value="lighter"/>
          <el-option label="普通" value="normal"/>
          <el-option label="粗体" value="bold"/>
          <el-option label="加粗体" value="bolder"/>
        </el-select>
      </el-form-item>
      <el-form-item labelAlign="left" label="维度省略字数">
        <el-input-number min='0' v-model="main.activeOption.titleEllipsis" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标字色" tip="配置单个指标数值的样式">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.valueColor"></el-color-picker>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标字号">
        <el-input-number min='0' v-model="main.activeOption.valueFontSize" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标字重">
        <el-select clearable v-model="main.activeOption.valueWeight" size="small">
          <el-option label="细" value="lighter"/>
          <el-option label="普通" value="normal"/>
          <el-option label="粗体" value="bold"/>
          <el-option label="加粗体" value="bolder"/>
        </el-select>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标省略字数">
        <el-input-number min='0' v-model="main.activeOption.valueEllipsis" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字色">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.unitColor"></el-color-picker>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字号">
        <el-input-number min='0' v-model="main.activeOption.unitFontSize" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字重">
        <el-select clearable v-model="main.activeOption.unitWeight" size="small">
          <el-option label="细" value="lighter"/>
          <el-option label="普通" value="normal"/>
          <el-option label="粗体" value="bold"/>
          <el-option label="加粗体" value="bolder"/>
        </el-select>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标来源">
        <el-switch v-model="main.activeOption.showOrigin"/>
      </el-form-item>
      <el-form-item v-if="main.activeOption.showOrigin" labelAlign="left" label="指标来源X">
        <el-input-number v-model="main.activeOption.originX" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item v-if="main.activeOption.showOrigin" labelAlign="left" label="指标来源Y">
        <el-input-number v-model="main.activeOption.originY" size="small" controls-position="right"/>
      </el-form-item>
      <div class="color b pl-10">辅助指标:</div>
      <el-form-item labelAlign="left" label="维度字色" tip="配置辅助指标的描述字体颜色">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.assistDesColor"></el-color-picker>
      </el-form-item>
      <el-form-item tip="配置辅助指标的描述字体大小" labelAlign="left" label="维度字号">
        <el-input-number min='0' v-model="main.activeOption.assistDesFontSize" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="指标字色" tip="配置辅助指标的值字体颜色">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.assistColor"></el-color-picker>
      </el-form-item>
      <el-form-item tip="配置辅助指标的值字体大小" labelAlign="left" label="指标字号">
        <el-input-number min='0' v-model="main.activeOption.assistFontSize" size="small" controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字色">
        <el-color-picker :predefine="predefineColors" v-model="main.activeOption.assistUnitColor"></el-color-picker>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字号">
        <el-input-number min='0' v-model="main.activeOption.assistUnitFontSize" size="small"
                         controls-position="right"/>
      </el-form-item>
      <el-form-item labelAlign="left" label="单位字重">
        <el-select clearable v-model="main.activeOption.assistUnitWeight" size="small">
          <el-option label="细" value="lighter"/>
          <el-option label="普通" value="normal"/>
          <el-option label="粗体" value="bold"/>
          <el-option label="加粗体" value="bolder"/>
        </el-select>
      </el-form-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script setup>
import {ArrowDown} from "@element-plus/icons-vue";
import {CARD_TYPE, predefineColors} from "@/option/common/dict.js";
</script>

<script>
export default {
  name: "indexCard",
  inject: ["main"],
  methods: {
    changeColor(v) {
      this.main.activeOption.selectedColorIndex = v;
    }
  }
};
</script>

<style></style>